export var Products;
(function (Products) {
    Products["myTenNights"] = "mytennights";
    Products["myTenDays"] = "mytendays";
    Products["fridayGiving"] = "fridaygiving";
})(Products || (Products = {}));
export var ProductName;
(function (ProductName) {
    ProductName["myTenNights"] = "MyTenNights";
    ProductName["myTenDays"] = "MyTenDays";
    ProductName["fridayGiving"] = "FridayGiving";
    ProductName["everGive"] = "EverGive";
    ProductName["myFridays"] = "MyFridays";
})(ProductName || (ProductName = {}));
export var ProductType;
(function (ProductType) {
    ProductType["fridayGiving"] = "fridayGiving";
    ProductType["everGive"] = "everGive";
})(ProductType || (ProductType = {}));
export var RecordType;
(function (RecordType) {
    RecordType["FGS"] = "FGS";
    RecordType["WFS"] = "WFS";
    RecordType["RUN"] = "RUN";
})(RecordType || (RecordType = {}));
export const campaignPlatform = 'platform';
export var ScheduleType;
(function (ScheduleType) {
    ScheduleType["FridayGiving"] = "Friday Giving";
    ScheduleType["EverGive"] = "EverGive";
})(ScheduleType || (ScheduleType = {}));
export var CampaignSource;
(function (CampaignSource) {
    CampaignSource["CHARITY"] = "CHARITY";
    CampaignSource["SHAMAAZI"] = "SHAMAAZI";
})(CampaignSource || (CampaignSource = {}));
export function getCampaignSource(source) {
    const matchedValue = Object.values(CampaignSource).find(value => value.toLowerCase() === source.toLowerCase());
    return matchedValue || CampaignSource.SHAMAAZI;
}
export const isMultiCharity = (charityId) => charityId.startsWith('multi-charity');
export function charityTotal(causes) {
    return Object.values(causes).reduce((sum, val) => sum + val, 0);
}
export function totalFee(causesFee, tipFee) {
    return causesFee + tipFee;
}
export function CharityTotal(causes) {
    let total = 0;
    for (const a of Object.values(causes)) {
        total += a;
    }
    return total;
}
export function grossAmount(causesFee, tipFee, payFees, causes) {
    let gross = CharityTotal(causes);
    if (payFees) {
        gross += causesFee + tipFee;
    }
    return gross;
}
//# sourceMappingURL=data:application/json;base64,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